<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <v-layout justify-space-between align-center>
        <div style="font-size: 11px">
          <span style="font-weight: bold">ID: </span>
          <span class="mr-3">
            {{ assetReservationObject.asset_reservation.ar_id }}
          </span>

          <span style="font-weight: bold">{{ $t("ExternalID") }}: </span>
          <span>
            {{ getAssetReservationExternalID() }}
          </span>
        </div>

        <v-btn
          v-if="!disabled && hasPermission('update')"
          @click.stop="saveChanges"
          :disabled="!saveIsEnabled"
          x-small
          icon
          text
          color="accent"
          class="my-0"
        >
          <v-icon size="15">save</v-icon>
        </v-btn>
      </v-layout>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-card-text style="background-color: #f0f0ef">
          <v-layout row wrap>
            <input-field
              v-for="field in fields"
              :key="field.label + field.order"
              ref="formInputField"
              :value="getValueInObject(field.var_name)"
              @input="setValueInObject(field.var_name, $event)"
              :label="field.label"
              :variable-name="field.var_name"
              :inputType="field.input_type"
              :size="field.size"
              :required="field.required"
              :selectOptions="field.select_list_name"
              :radioOptions="field.radio_options"
              :fieldDisabled="field.disable"
              :formDisabled="disabled"
              :hide="field.hide"
            >
              <div
                v-if="field.input_type === 'checkbox'"
                class="checkbox-group"
              >
                <v-checkbox
                  v-for="checkbox in field.checkbox_options"
                  :key="checkbox.label"
                  :label="checkbox.label"
                  color="#4fa2b7"
                  :ripple="false"
                  :disabled="disabled || field.disable"
                  :value="getValueInObject(checkbox.var_name)"
                  @input="setValueInObject(checkbox.var_name, $event)"
                />
              </div>
            </input-field>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import _ from "lodash";
import { mapActions } from "vuex";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";

export default {
  name: "AssetReservationObjectPanel",

  components: { AppDialogBox, InputField },

  mixins: [checkPermissionsMixin],

  props: {
    objectUuid: {
      type: String,
      required: true
    },

    originalAssetReservationObject: {
      type: Object,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    fields: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      assetReservationObject: {},
      dataToSend: {},

      deleteDialog: false,
      saveIsEnabled: false
    };
  },

  created() {
    if (this.originalAssetReservationObject) {
      this.assetReservationObject = JSON.parse(
        JSON.stringify(this.originalAssetReservationObject)
      );
    }
  },

  methods: {
    ...mapActions(["editAssetReservationObject"]),

    getAssetReservationExternalID() {
      let id = this.assetReservationObject.asset_reservation.ar_external_id;
      if (!id) {
        id = " - ";
      }
      return id;
    },

    hasPermission(action) {
      return this.userHasFibercloudPermission(
        "asset_reservation_object",
        action
      );
    },

    getValueInObject(varName) {
      return _.get(this.assetReservationObject, varName);
    },

    setValueInObject(varName, newValue) {
      _.set(this.assetReservationObject, varName, newValue);
      this.updateDataToSend(varName, newValue);
    },

    updateDataToSend(varName, newValue) {
      let dataToSendVarName = varName.replace("aro_", "");
      _.set(this.dataToSend, dataToSendVarName, newValue);
      this.saveIsEnabled = Object.entries(this.dataToSend).length > 0;
    },

    async saveChanges() {
      let assetReservation = this.assetReservationObject.asset_reservation;
      let assetReservationUUID = assetReservation.ar_uuid;

      this.toggleLoading(true);
      try {
        let updatedAssetReservationObject = await this.editAssetReservationObject(
          {
            assetReservationUUID,
            objectUUID: this.objectUuid,
            assetReservationObject: this.dataToSend
          }
        );
        updatedAssetReservationObject.asset_reservation = assetReservation;

        this.resetPanel(updatedAssetReservationObject);
        this.$emit(
          "update-asset-reservation-object",
          updatedAssetReservationObject
        );
      } catch (error) {
        this.$toasted.global.toast_error(error.data.data);
      }
      this.toggleLoading(false);
    },

    resetPanel(updatedAssetReservationObject) {
      this.assetReservationObject = updatedAssetReservationObject;
      this.dataToSend = {};
      this.saveIsEnabled = false;
    },

    toggleLoading(isLoading) {
      this.$emit("update-loading", isLoading);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationObjectPanel.vue